import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  actions,
  className = '',
  padding = 'p-6',
  shadow = 'shadow-card',
  hoverable = false,
  ...props
}) => {
  const cardClasses = [
    'bg-white rounded-2xl border border-ink-200/70',
    shadow,
    padding,
    hoverable
      ? 'transition-all duration-200 hover:shadow-pop hover:border-ink-300/70 hover:-translate-y-0.5'
      : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const hasHeader = title || subtitle || actions;

  return (
    <div className={cardClasses} {...props}>
      {hasHeader && (
        <div className="mb-5 flex items-start justify-between gap-4">
          <div className="min-w-0">
            {title && (
              <h3 className="text-base font-semibold text-ink-900 tracking-tight">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="mt-1 text-sm text-ink-500">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 shrink-0">{actions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
